export const locale = {
  lang: 'id',
  data: {
    'TOOLBAR': {
      'MENU': {
        'PROFILE': 'Profil Saya',
        'LOGOUT': 'Keluar'
      },
    }
  }
};
